import { render, staticRenderFns } from "./Debit1372.vue?vue&type=template&id=720bdc0a&"
import script from "./Debit1372.vue?vue&type=script&lang=js&"
export * from "./Debit1372.vue?vue&type=script&lang=js&"
import style0 from "./Debit1372.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports